// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-section{border:4px solid transparent;position:relative}.form-section__edit-button{position:absolute;right:1.5rem;top:1.5rem}@media screen and (min-width:48em){.form-section__edit-button{right:2rem;top:2rem}}@media screen and (min-width:82.5em){.form-section__edit-button{right:3rem;top:3rem}}.form-section--is-edit-mode{border-color:#000}", ""]);
// Exports
module.exports = exports;
